export const shiftTargetAmount = 18;
export const weekendsTargetAmount = 4;
export const rdoMaxAmount = 6;

export const validateWeekendsAmount = (weekends: number): boolean => {
	return weekends >= weekendsTargetAmount;
};

export const validateRDOAmount = (rdos: number): boolean => {
	return rdos <= rdoMaxAmount;
};

export const validateTotalShiftAmount = (shiftsAmount: number): boolean => {
	return shiftsAmount >= shiftTargetAmount;
};
